import { render, staticRenderFns } from "./newsletter-form.vue?vue&type=template&id=2d812939"
import script from "./newsletter-form.vue?vue&type=script&lang=js"
export * from "./newsletter-form.vue?vue&type=script&lang=js"
import style0 from "./newsletter-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports